import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Container,
  CssBaseline,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Toolbar,
  Typography,
} from '@mui/material';
import Selector from '../../../components/Selector'
import { fetchSucursales, fetchUsuarios } from '../../../utils/generalsFetch';

const AgregarAlmacen = ({ open, onClose }) => {
  const [branches, setBranches] = useState([]);
  const [branchesSelected, setBranchesSelected] = useState([]); 
  const [users, setUsers] = useState([]);
  const [usersSelected, setUsersSelected] = useState([])
  const [nombre, setNombre] = useState("")
  const [direccion, setDireccion] = useState("")
  const [errors, setErrors] = useState({});
  const [error, setError] = useState('');

  useEffect(() => {
    fetchSucursales({ idcompany: localStorage.getItem('idcompany'), usuarioId: localStorage.getItem('id') })
    .then((data) => {
      setBranches(data);
    })
    .catch(err => setError(err.message));

    fetchUsuarios({ idcompany: localStorage.getItem('idcompany'), usuarioId: localStorage.getItem('id') })
    .then((data) => {
      console.log("data: ",data)
      setUsers(data);
    })
    .catch(err => console.log(err.message));

    }, []);

  // Validation function
  const validateFields = () => {
    let newErrors = {};
    if (!nombre || nombre.trim() === "") {
      newErrors.nombre = "El nombre del almacén es obligatorio.";
    }
    if (!direccion || direccion.trim() === "") {
      newErrors.direccion = "La dirección del almacén es obligatoria.";
    }
    if (!branchesSelected || branchesSelected.length === 0) {
      newErrors.branchesSelected = "Debe seleccionar al menos una sucursal.";
    }
    if (!usersSelected || usersSelected.length === 0) {
      newErrors.usersSelected = "Debe seleccionar al menos un usuario responsable.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

    async function crearAlmacen() {
      if (!validateFields()) {
        return;
      }
      const url = `${process.env.REACT_APP_SERVER_URL}/api/almacenes`;
    
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
          },
          body: JSON.stringify({
            nombre,
            direccion,
            idcompany:localStorage.getItem('idcompany'),
            usersSelected,
            branchesSelected,
            created_by: localStorage.getItem('id')

          })
        });
    
        const text = await response.text();
        try {
          const data = JSON.parse(text);
          if (!response.ok) {
            throw new Error(data.error || 'Error al crear almacén');
          }
          onClose()
        } catch (e) {
          throw new Error('Respuesta no es JSON: ' + text);
        }
      } catch (error) {
        setErrors(prev => ({...prev, general: error.message || 'Error desconocido'}));
        throw error;
      }
    }
    

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h5" fontWeight="bold">Agregar Almacén</Typography>
      </DialogTitle>
      <DialogContent>
        <Box py={1}>
          <TextField
            value={nombre}
            onChange={(e)=>{setNombre(e.target.value)}}
            placeholder="Nombre del Almacén"
            fullWidth
            variant="outlined"
            sx={{ mb: 3 }}
            error={!!errors.nombre}
            helperText={errors.nombre}
          />
          <TextField
            value={direccion}
            onChange={(e)=>{setDireccion(e.target.value)}}
            placeholder="Direccion del Almacén"
            fullWidth
            variant="outlined"
            sx={{ mb: 3 }}
            error={!!errors.direccion}
            helperText={errors.direccion}
          />

          <FormControl fullWidth sx={{ mb: 3 }}>
              <Selector
                  multiple
                  value={branchesSelected}
                  onChange={(e) => {
                    setBranchesSelected(e.target.value);
                  }}
                  options={branches}
                  placeholder="Seleccione una o varias sucursales"
              />
              {errors.branchesSelected && (
                <Typography color="error" variant="body2" fontSize={12} sx={{marginLeft:2}}>{errors.branchesSelected}</Typography>
              )}
          </FormControl>

          <FormControl fullWidth>
            <Selector
                  multiple
                  value={usersSelected}
                  onChange={(e) => {
                    setUsersSelected(e.target.value);
                  }}
                  options={users}
                  placeholder="Usuarios responsables"
            />
            {errors.usersSelected && (
              <Typography color="error" variant="body2" fontSize={12} sx={{marginLeft:2}}>{errors.usersSelected}</Typography>
            )}
          </FormControl>
        {errors.general && (
          <Typography color="error" variant="body2" sx={{ mt: 2 }}>{errors.general}</Typography>
        )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined">Cancelar</Button>
        <Button variant="contained" color='primarybutton' sx={{ fontWeight:"bold" }} onClick={()=>{crearAlmacen()}}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AgregarAlmacen;
